import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { LogOut, Shield, Users, ChevronRight, Settings } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";
import { useAuth } from "@/hooks/useAuth";

export default function AdminConfiguracoes() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleLogout = async () => {
    await supabase.auth.signOut();
    toast({ title: "Deslogado com sucesso" });
    navigate("/admin/login");
  };

  return (
    <div className="p-8 max-w-4xl">
      <motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} className="mb-8">
        <h1 className="font-heading text-2xl font-bold text-foreground">Configurações</h1>
        <p className="text-muted-foreground text-sm mt-1">Gestão de acessos e configurações do admin</p>
      </motion.div>

      <div className="space-y-6">
        {/* Conta Admin */}
        <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }}
          className="bg-card rounded-2xl p-6 border border-border">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center">
              <Shield className="w-5 h-5 text-primary" />
            </div>
            <h2 className="font-heading text-lg font-semibold text-foreground">Conta Administrador</h2>
          </div>
          <div className="bg-secondary/50 rounded-xl p-4">
            <p className="text-sm font-medium text-foreground">{user?.email}</p>
            <p className="text-xs text-muted-foreground mt-1">Administrador do sistema</p>
          </div>
        </motion.div>

        {/* Gestão de Acessos */}
        <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }}
          className="bg-card rounded-2xl p-6 border border-border">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-xl bg-accent/20 flex items-center justify-center">
              <Users className="w-5 h-5 text-accent" />
            </div>
            <h2 className="font-heading text-lg font-semibold text-foreground">Gestão de Acessos</h2>
          </div>
          <div className="space-y-2">
            <button onClick={() => navigate("/admin/parceiros")}
              className="w-full flex items-center justify-between p-3 bg-secondary/50 rounded-xl hover:bg-secondary transition-colors">
              <div className="flex items-center gap-3">
                <Settings className="w-5 h-5 text-primary" />
                <span className="text-sm font-medium text-foreground">Gerenciar Parceiros</span>
              </div>
              <ChevronRight className="w-4 h-4 text-muted-foreground" />
            </button>
            <button onClick={() => navigate("/admin/auditoria")}
              className="w-full flex items-center justify-between p-3 bg-secondary/50 rounded-xl hover:bg-secondary transition-colors">
              <div className="flex items-center gap-3">
                <Shield className="w-5 h-5 text-muted-foreground" />
                <span className="text-sm font-medium text-foreground">Log de Auditoria</span>
              </div>
              <ChevronRight className="w-4 h-4 text-muted-foreground" />
            </button>
          </div>
        </motion.div>

        {/* LGPD */}
        <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3 }}
          className="bg-primary/5 rounded-xl p-4 border border-primary/10">
          <Shield className="w-6 h-6 text-primary mb-2" />
          <p className="text-sm font-medium text-foreground mb-1">Conformidade LGPD</p>
          <p className="text-xs text-muted-foreground">
            Todos os dados são tratados conforme a Lei Geral de Proteção de Dados. Acesse a Auditoria para logs de acesso.
          </p>
        </motion.div>

        {/* Logout */}
        <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.4 }}>
          <Button variant="destructive" size="lg" className="w-full" onClick={handleLogout}>
            <LogOut className="w-5 h-5" />
            Sair do Painel Admin
          </Button>
        </motion.div>
      </div>
    </div>
  );
}
